import { FC, HTMLProps } from 'react';
import cx from 'classnames';

import styles from './Card.module.scss';

export type CardProps = Pick<HTMLProps<HTMLDivElement>, 'className' | 'children' | 'onClick'>;

const Card: FC<CardProps> = ({ children, className, ...htmlProps }): JSX.Element => (
  <div className={cx(className, styles.container)} {...htmlProps}>
    {children}
  </div>
);

export default Card;
